module.exports = __webpack_public_path__ + "img/vantagensavalize.3b9c0a6d.png";